import { createContext } from 'react';
import { IUserRoles } from '../models';

interface PermissionsContextType {
    permissions?: IUserRoles[];
}

export const PermissionsContext = createContext<PermissionsContextType>({});
